import style from './style.css.scss'

export function scrollToElement(elemClass) {
  const itemViewerElement = document.getElementsByClassName(elemClass)[0]
  const viewportOffset = window.innerHeight - style.headerHeight
  window.scrollTo(0, itemViewerElement.offsetTop + viewportOffset)
}